export default function MapControls({children}){

    return (
        <div className='absolute top-0 right-0 p-0 m-3'>
            {children}
        </div>
    )
}